import Global from '../shared/global';

const $ = jQuery.noConflict();

'use strict';
const equalHeightsItems = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	/** @description Initialize */
	init: function() {
		this.equalHeight();
	},

	/** @description slider example description e.g Banner slider */
	equalHeight: () => {
		if ($(window).width() > 576) {
			Global.equalHeights($('.js-card-info-equal-height'));
			Global.equalHeights($('.property-listings__name'));
			Global.equalHeights($('.property-listings__address'));
			Global.equalHeights($('.property-listings__info'));
			Global.equalHeights($('.property-listings__date'));
			Global.equalHeights($('.property-cards__name'));
		}

		if ($(window).width() > 992) {
			Global.equalHeights($('.js-banner-card-item-equal-height'));
		}
	}
};

export default equalHeightsItems;


